// Fonte única das fórmulas clínicas da avaliação.
//
// Consumido pelos três lugares que precisam dos mesmos números: a tela
// (frontend/src/views/RecordForm.vue, via alias `@shared`), o relatório PDF
// (api/services/dao/ReportService.js) e a conclusão (api/services/dao/ConclusionService.js,
// de onde a ACIA herda). Antes cada um tinha sua cópia e elas divergiam em silêncio.
//
// Regras da casa:
// - funções puras, sem Sails, sem Vue, sem I/O — dá para testar em Node cru;
// - `null` significa "não dá para calcular"; formatação ('--', 'Não calculado', '%')
//   é responsabilidade de quem exibe;
// - zero é resultado válido de teste, não marcador de ausência.

const primitives = require('./primitives');
const symmetry = require('./symmetry');
const shoulder = require('./shoulder');
const ankle = require('./ankle');
const trunk = require('./trunk');
const throwTests = require('./throw');

module.exports = {
    ...primitives,
    ...symmetry,
    ...shoulder,
    ...ankle,
    ...trunk,
    ...throwTests
};
